import { render, staticRenderFns } from "./DaysInfo.vue?vue&type=template&id=30f61d90&"
import script from "./DaysInfo.vue?vue&type=script&lang=js&"
export * from "./DaysInfo.vue?vue&type=script&lang=js&"
import style0 from "./DaysInfo.vue?vue&type=style&index=0&lang=sass&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports